/** Stable element ids for global error page actions (e2e + a11y). */
export const GLOBAL_ERROR_ELEMENT_IDS = {
  RETURN_HOME: 'global-error-return-home',
  RETRY: 'global-error-retry',
  GO_BACK: 'global-error-go-back',
  CONTACT_SUPPORT: 'global-error-contact-support',
  ILLUSTRATION: 'global-error-illustration',
  HEADER: 'global-error-header',
} as const

/** Shared error illustration (same asset family as meet invalid-session). */
export const GLOBAL_ERROR_ILLUSTRATION_URL =
  'https://storage.googleapis.com/staging-revex-meet-ssr-preview/assets/invalid-session-illustration.svg'
